export default __webpack_public_path__ + "static/latitude-infinity-67f7b0566bde5d654ae9d0b39a1b845b.png";